import {
    type SwipeCallback,
    type SwipeableDirectionCallbacks,
    type TapCallback,
    useSwipeable,
} from "react-swipeable";
import type { ConfigurationOptions } from "react-swipeable/es/types";

export default function Swipeable (props: React.PropsWithChildren<{
    className?: string;
    style?: React.CSSProperties;
    handlers: Partial<SwipeableDirectionCallbacks & ConfigurationOptions & {
        onSwipeStart: SwipeCallback;
        onSwiped: SwipeCallback;
        onSwiping: SwipeCallback;
        onTap: TapCallback;
        onTouchStartOrOnMouseDown: TapCallback;
        onTouchEndOrOnMouseUp: TapCallback;
    }>;
}>)
{
    const handlers = useSwipeable(props.handlers);

    return (
        <div
            className={props.className}
            style={props.style}
            {...handlers}
        >
            {props.children}
        </div>
    );
}
